import type { PropsWithChildren, ReactNode } from 'react';
import { Button, type ButtonProps } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

import { CircularProgress } from './circular-progress';

type Props = PropsWithChildren<{
  icon?: ReactNode;
  loading?: boolean;
  iconClassName?: string;
  className?: string;
}> &
  ButtonProps;

export const SecondaryButton = ({ loading, icon, type = 'button', iconClassName, ...rest }: Props) => {
  const { children, isDisabled, className, ...props } = rest;

  return (
    <Button
      {...props}
      type={type}
      isDisabled={isDisabled || loading}
      className={twMerge(
        'flex items-center justify-center gap-[5px] rounded-[4px] border border-[#d9d9d9] bg-transparent text-[14px] text-black shadow-sm hover:bg-[#abacb51a] active:text-[#00000070] disabled:text-[#00000070]',
        className,
      )}
    >
      {children}
      {loading && <CircularProgress className={twMerge('h-[12px] w-[12px] text-[#00000070]', iconClassName)} />}
      {!loading && icon}
    </Button>
  );
};
